/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, IconButton, makeStyles, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, IconButtonWrapper } from '../Common';
import { ChartFilter } from '../ChartComponents';
// import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { convertStringNumberToNumber, formatNumber, getLabels, getMaxTickLimit, getSuggestedMaxTick } from '../../helpers/ChartHelper';
// import { DrillDownType } from '../DrillDownType';
import { SelectedItemProps } from '../MattersByStatusChart';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { SearchCriteria } from '../SearchCriteria';
import { DrillDownType } from '../DrillDownType';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Scale, Tick, Chart, ChartEvent, ActiveElement } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { ChartInfo } from '../../components/ChartInfo';

import { RV_CHART_CLASS, isChartDataEmpty, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvTooltipStyle, rvValueAxisStyle } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartEmptyState } from '../ChartEmptyState';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '20px 15px 0px 15px',
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            minHeight: '300px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
        },
        total: {
            fontSize: '2.5rem',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
    }),
);

export enum SalesPipelineOptionEnum {
    ESTIMATED_FEES = 0,
    PIPELINE,
}
interface DueDatesOverviewChartProps extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
}

interface ChartState {
    totalDueDatesCount: number;
    groupBy: string[];
    dueDatesCount: number[];
    matterCount: number[];
}

export const DueDatesOverviewChart: React.FC<DueDatesOverviewChartProps> = (props) => {
    const classes = useStyles();

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const dueDatesOverviewQuery = useQuery<DueDatesOverviewData, DueDatesOverviewParams>(DUE_DATES_OVERVIEW_QUERY, {
        variables: {
            entityType: props.chartFilter?.entityType,
            entityGuid: props.chartFilter?.entityGuid,
            responsibility: props.chartFilter?.responsibility,
        },
        fetchPolicy: 'cache-and-network',
    });

    const [state, setState] = useState<ChartState>({
        groupBy: [],
        dueDatesCount: [],
        matterCount: [],
        totalDueDatesCount: 0,
    });

    useEffect(() => {
        if (
            dueDatesOverviewQuery.data &&
            dueDatesOverviewQuery.data.statistics &&
            dueDatesOverviewQuery.data.statistics.matter &&
            dueDatesOverviewQuery.data.statistics.matter.dueDatesOverview &&
            !dueDatesOverviewQuery.error &&
            !dueDatesOverviewQuery.loading
        ) {
            setState((prevState) => {
                const { dueDatesOverviewByGroup, totalDueDatesCount } = dueDatesOverviewQuery.data!.statistics.matter.dueDatesOverview;
                return {
                    ...prevState,
                    totalDueDatesCount,
                    groupBy: dueDatesOverviewByGroup.map((overview: DueDatesOverviewByGroup) => overview.groupedBy),
                    dueDatesCount: dueDatesOverviewByGroup.map((overview: DueDatesOverviewByGroup) => overview.dueDatesCount),
                    matterCount: dueDatesOverviewByGroup.map((overview: DueDatesOverviewByGroup) => overview.matterCount),
                };
            });
        }
        // tslint:disable-next-line: align
    }, [dueDatesOverviewQuery.data, dueDatesOverviewQuery.error, dueDatesOverviewQuery.loading]);

    const onCloseChart = () => {
        if (props.onCloseChart) {
            props.onCloseChart(`isDueDatesOverviewChartOpen`);
        }
    };

    const handleTotalClick = () => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();

            searchCriterias.push({ property: 'DueDates', operator: 'eq', comparison: '' });

            props.getSelectedItem(searchCriterias, false, `Due Dates`, DrillDownType.matterSummaryDrilldown, 'Next Due Date');
        }
    };

    const formatGroupByToExactLabel = (groupBy: string) => {
        if (groupBy === 'NextSevenDays') {
            return 'Next 7 days';
        } else if (groupBy === 'NextEightToThirtyDays') {
            return 'Next 8 - 30 days';
        } else {
            return groupBy;
        }
    };

    const onPan = (context: { chart: Chart }) => {
        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    const onHover = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    };
    
    if (dueDatesOverviewQuery.loading) {
        return (
            <ChartSkeleton variant="bars" />
        );
    }

    return (
        <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty(state.dueDatesCount) ? ' rv-chart--empty' : ''}`}>
            <IconButtonWrapper aria-label="close">
                <ChartInfo 
                    description={props.description}
                    fontSize={props.showAllRecords ? 'large' : 'medium'}
                    className={`${classes.helpIcon} rv-chart-help`}
                />
                <IconButton aria-label="close" onClick={onCloseChart} size="small">
                    <CloseIcon className={classes.closeIcon} />
                </IconButton>
            </IconButtonWrapper>
            <div className={classes.titleContainer}>
                <ChartHeading icon={<EventOutlinedIcon />} title="Due Dates" />
                <div className={`${classes.total} h2`} onClick={handleTotalClick}>
                    <AnimatedNumber value={state.totalDueDatesCount} format={(amount) => `${formatNumber(amount)}`} />
                </div>
            </div>
            <div className={classes.barContainer}>
                <Bar
                    ref={chartRef}
                    // tslint:disable-next-line: no-any
                    onClick={(event: React.MouseEvent<any>) => {
                        const _data = getElementAtEvent(chartRef.current, event);
                        if (_data.length > 0 && props.getSelectedItem) {
                            const _index = getElementAtEvent(chartRef.current, event)[0].index;

                            const _groupBy = state.groupBy[_index];
                            const searchCriterias = new Array<SearchCriteria>();
                            searchCriterias.push({
                                property: 'DueDates',
                                operator: 'eq',
                                comparison: _groupBy,
                            });

                            props.getSelectedItem(
                                searchCriterias, 
                                false, 
                                `Due Dates by ${formatGroupByToExactLabel(_groupBy)}`, 
                                DrillDownType.matterSummaryDrilldown, 
                                'Next Due Date'
                            );
                        }
                    }}
                    data={{
                        labels: getLabels(state.groupBy.map((_groupBy: string) => formatGroupByToExactLabel(_groupBy))),
                        datasets: [
                            {
                                label: 'Dates',
                                ...rvBarDatasetStyle(['#c00000', '#ed7d31', '#92d050', '#0070c0', '#00b0f0'], true),
                                data: state.dueDatesCount,
                            },
                        ],
                    }}
                    options={{
                        onHover: onHover,
                        indexAxis: 'y' as const,
                        animation: rvChartAnimation(),
                        elements: { bar: { borderWidth: 0 } },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            x: {
                                grid: rvValueAxisStyle.grid,
                                // beginAtZero: true,
                                stacked: true,
                                suggestedMax: getSuggestedMaxTick(state.dueDatesCount),
                                beginAtZero: true,
                                ticks: {
                                    ...rvValueAxisStyle.ticks,
                                    maxTicksLimit: getMaxTickLimit(state.dueDatesCount),
                                    autoSkip: false,
                                    callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                        return `${formatNumber(tickValue)}`;
                                    },
                                },
                            },
                            y: {
                                grid: rvCategoryAxisStyle.grid,
                                stacked: true,
                                ticks: {
                                    ...rvCategoryAxisStyle.ticks,
                                    autoSkip: false,
                                }
                                // min: 0,
                                // max: 9 // minimum display
                            }
                        },
                        plugins: {
                            legend: {
                                position: 'bottom' as const,
                                display: false,
                            },
                            title: {
                                display: false,
                                text: ``,
                            },
                            zoom: {
                                pan: {
                                    enabled: false,
                                    onPan: onPan,
                                },
                                zoom: {
                                    wheel: {
                                        enabled: false,
                                    },
                                },
                                // limits: {
                                //   y: { min: 0, max: 9 },
                                // },
                            },
                            tooltip: {
                                ...rvTooltipStyle,
                                callbacks: {
                                    // tslint:disable-next-line: no-any
                                    label: function (context: any) {
                                        const {
                                            //   dataIndex,
                                            //   label,
                                            formattedValue,
                                            dataset,
                                        } = context;

                                        var currentValue = convertStringNumberToNumber(formattedValue);

                                        return [`${dataset.label}: ${formatNumber(currentValue)}`];
                                    },
                                    // tslint:disable-next-line: no-any
                                    afterLabel: function (context: any) {
                                        const { dataIndex} = context;

                                        const matters = state.matterCount[dataIndex];

                                        return [
                                            `Matters: ${formatNumber(matters)}`,
                                        ];
                                    },
                                },
                            },
                        },
                    }}
                />
                {isChartDataEmpty(state.dueDatesCount) && (
                    <ChartEmptyState title="No data" hint="Nothing to show for this selection." />
                )}
            </div>
            {/* <span className={classes.span}>{formatNumber(state.openEnquiryCount)} open enquiries have no Fee Estimate</span> */}
            {/* <span className={classes.span}>Drill down to timekeeper details</span>     
            <span className={classes.span}>The top 10 timekeepers are shown</span>                           */}
        </div>
    );
};

export interface DueDatesOverviewParams {
    entityType?: number;
    entityGuid?: string;
    responsibility?: number;
}

export interface DueDatesOverviewData {
    statistics: Statistics;
}

export interface Statistics {
    matter: Matter;
}

export interface Matter {
    dueDatesOverview: DueDatesOverview;
}

export interface DueDatesOverview {
    dueDatesOverviewByGroup: DueDatesOverviewByGroup[];
    totalDueDatesCount: number;
}

export interface DueDatesOverviewByGroup {
    dueDatesCount: number;
    groupedBy: string;
    matterCount: number;
}

const DUE_DATES_OVERVIEW_QUERY = gql`
    query dueDatesOverviewChart($entityType: Int, $entityGuid: String, $responsibility: Int) {
        statistics {
            matter {
                dueDatesOverview(entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility) {
                    dueDatesOverviewByGroup {
                        dueDatesCount
                        groupedBy
                        matterCount
                    }
                    totalDueDatesCount
                }
            }
        }
    }
`;
